import { useToken } from "../../../server/auth/use-token";
import { AtlasV2Service } from "../../search/atlas/client";
import { PAGE_SIZE, usePagedFeed } from "./use-paged-feed";

import type { PagedFeed } from "./use-paged-feed";
import type { FeedItem, RecentlyEditedType } from "./use-recently-edited";

/**
 * The Communications, Surveys and Digital Assets matching `q`, best first, a page at a time. With
 * `entityType`, only that kind. Each as the Recently edited feed has it, to be shown alike. Nothing
 * while `q` is empty.
 */
export function useContentSearch(q: string, entityType?: RecentlyEditedType): PagedFeed<FeedItem> {
  const getToken = useToken();

  return usePagedFeed<FeedItem>(
    async ({ abortController }, offset) => {
      // Nothing searched yet.
      if (!q) return [];
      // Cancelled when this search is replaced: a new query or kind, the same search again, or
      // leaving the page.
      const { data, error } = await new AtlasV2Service().searchContent(getToken, q, {
        count: PAGE_SIZE,
        offset,
        entityType,
        signal: abortController?.signal,
      });
      if (error) throw error;
      return data;
    },
    [q, entityType, getToken],
  );
}
